import React from 'react';
import {UpdateUserInput, User} from '../../graphql';
import {UniversalCard} from '../Cards/UniversalCard';
import {UserForm} from '../Form/UserForm';

interface UserEditViewProps {
  user: User;
  updateUser: Function;
}

export const UserEditView = ({user, updateUser}: UserEditViewProps) => {
  return (
    <UniversalCard title="Edit User">
      <UserForm user={user} onSubmit={(values: UpdateUserInput) => updateUser(values)}/>
    </UniversalCard>
  );
};
